import React from 'react';
import { useTranslation } from 'next-i18next';
import * as S from './Trait.styles';
export const Trait = ({
  label,
  value
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(S.Wrapper, null, t(label), ": ", /*#__PURE__*/React.createElement(S.Value, null, value));
};